import { Box } from "@chakra-ui/react";
import { CountryCode, parsePhoneNumberFromString } from "libphonenumber-js/max";
import { Control, Controller } from "react-hook-form";
import PhoneInput from "react-phone-number-input";

import { $length, $ok } from "foundation-ts/commons";

import { CustomCountrySelect } from "./CustomCountrySelect";

interface PhonenumberProps {
    height: number;
    authorizedCountries: string[];
    control: Control
}

export const Phonenumber = (props: PhonenumberProps) => {
    const { authorizedCountries, control, height } = props;

    return  (
        <Controller 
            name="phone"
            control={control}
            rules={{
                validate: (value) => {
                    if (!$ok(value)) { return true; }

                    try {
                        const phoneNumber = parsePhoneNumberFromString(value);
                        if ($length(phoneNumber?.nationalNumber) === 0) {
                            return true;
                        }
                        if (!phoneNumber?.isValid()) {
                            return "Le numéro de téléphone portable est invalide";
                        }

                        const type = phoneNumber.getType();
                        const isMobile = type === "MOBILE" || type === "FIXED_LINE_OR_MOBILE";
                        return isMobile || "Le numéro saisi n'est pas un numéro de téléphone portable";
                    } catch {
                        return "Le numéro de téléphone portable est invalide";
                    }
                }
            }}
            render={({ field: { onChange, value } }) => (
                <Box sx={{
                    ".PhoneInput": {
                        display: "flex",
                        alignItems: "stretch",
                        height: `${height}px`
                    },
                    ".PhoneInputInput": {
                        flex: 1,
                        height: `${height}px`,
                        border: "1px solid",
                        borderColor: "gray.200",
                        borderRadius: "md",
                        padding: "0 12px",
                        outline: "none",
                        fontSize: "md",
                        _focus: {
                            borderColor: "blue.400",
                            boxShadow: "0 0 0 1px #3182ce"
                        }
                    }}}
                >
                    <PhoneInput international defaultCountry="FR" value={value} countries={authorizedCountries as CountryCode[]} countrySelectComponent={CustomCountrySelect} onChange={(newValue) => onChange(newValue ?? "")} />
                </Box>
            )}
        />
    );
}